import {Typography} from '@mui/material';
import React from 'react';
import "../../index.css";
import {FixedBox} from "../Common/FixedContainer";

interface ErrorPageProps {
    code: number | null,
    galleryIdentifier:  string | null,
}

function ErrorPage({code, galleryIdentifier}: ErrorPageProps) {
    const getErrorMessage = (): string => {
        if (galleryIdentifier === null) {
            return "Gallery identifier not specified";
        }

        const errorCodeMessages: Record<string, string> = {
            401: "Couldn't access gallery data",
            403: "Couldn't access gallery data",
            404: "Gallery not found. The link you followed may be broken, or the page may have been removed.",
            500: "Unknown server error",
        }

        return code && code in errorCodeMessages ?
            errorCodeMessages[code] : "An unknown error occurred";
    }
    
    return (
        <FixedBox>
            <Typography variant="h4" gutterBottom sx={{color: "text.secondary"}}>
                An error occurred | {code || 400}
            </Typography>
            <Typography sx={{fontSize: "0.9rem", letterSpacing: "1px", color: "text.secondary"}}>
                {getErrorMessage()}
            </Typography>
        </FixedBox>
    );
}

export default ErrorPage;
